<template>
  <div class="home-container">
    <div class="home-content" v-if="seeFlags">
      <!-- 搜索 -->
      <div>
        <el-form :model="searchForm" ref="searchForm" label-width="80px">
          <el-row>
            <el-col :span="8">
              <el-form-item label="设备名称" prop="name" style="width: 80%">
                <el-input
                  v-model="searchForm.name"
                  placeholder="请输入设备名称"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="设备编号" prop="deviceNumber" style="width: 80%">
                <el-input
                  v-model="searchForm.deviceNumber"
                  placeholder="请输入设备编号"
                ></el-input>
              </el-form-item>
            </el-col>            
            <el-col :span="5">
              <el-button
                size="small"
                @click="onLoad()"
                type="primary"
                icon="el-icon-search"
                style="width: 90px"
                >搜索</el-button
              >
              <el-button
                size="small"
                @click="restSearch"
                type="danger"
                style="width: 90px"
                >重置</el-button
              >
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div style="margin: 20px">
        <el-button
          size="small"
          type="primary"
          icon="el-icon-plus"
          @click="add"
          style="width: 90px"
          >新增</el-button
        >
        <el-button
          size="small"
          plain
          type="primary"
          @click="downloadimg"
          style="width: 90px"
          >批量下载</el-button
        >
      </div>
      <el-table
        :data="tableData"
        style="width: 100%"
        ref="table"
        @select="handleSelect"
        type="selection"
        @select-all="handleSelectAll"
        v-loading="isShowloading"
        border
      >
        <el-table-column type="selection" width="40"> </el-table-column>
        <el-table-column prop="name" label="设备名称" align="center">
        </el-table-column>
        <el-table-column prop="deviceNumber" label="设备编号" align="center">
        </el-table-column>
        <el-table-column prop="deviceImg" label="设备图片" align="center">
          <template slot-scope="scope">
            <img :src="scope.row.deviceImg" min-width="70" height="70" />
          </template>
        </el-table-column>
        <el-table-column prop="deviceAddress" label="设备位置" align="center">
        </el-table-column>
        <el-table-column label="设备二维码" align="center">
          <template slot-scope="scope">
            <a v-if="scope.row.qrCode">
              <img
                :src="scope.row.qrCode"
                min-width="70"
                height="70"
                @click="addRecord(scope.row.qrCode)"
            /></a>

            <a v-else @click="qrCode(scope.row)">生成二维码</a>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建日期" align="center">
        </el-table-column>
        <el-table-column fixed="right" align="center" label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="see(scope.row)"
              >查看记录</el-button
            >
            <el-button type="text" size="small" @click="copyUpdata(scope.row)"
              >复制设备</el-button
            >
            <el-button type="text" size="small" @click="updata(scope.row)"
              >修改</el-button
            >
            <el-button @click="del(scope.row)" type="text" size="small"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页器 -->
      <div class="block" style="margin-top: 15px">
        <el-pagination
          align="center"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
      <!-- 新增模态框 -->
      <el-dialog :title="modalTitle" :visible.sync="isAddModal" width="50%">
        <el-form
          ref="form"
          :model="addData"
          label-width="90px"
          :rules="addDataRules"
          label-position="center"
        >
          <el-row>
            <el-col :span="12">
              <el-form-item label="设备名称" prop="name">
                <el-input
                  v-model="addData.name"
                  placeholder="请输入设备名称"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="设备编号" prop="deviceNumber">
                <el-input
                  v-model="addData.deviceNumber"
                  placeholder="请输入设备编号"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="设备位置" prop="deviceAddress">
                <el-input
                  v-model="addData.deviceAddress"
                  placeholder="请输入设备位置"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="设备图片" prop="deviceImg">
                <upload
                  :url.sync="addData.deviceImg"
                  :src="addData.deviceImg"
                ></upload>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="设备详细信息" label-width="120px">
                <el-table :data="tableDatas" border style="width: 100%">
                  <el-table-column prop="label" label="属性名" align="center">
                    <template slot-scope="{ scope, $index }">
                      <el-input
                        v-model="tableDatas[$index].label"
                        placeholder="请输入属性名"
                      ></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column prop="value" label="属性值" align="center">
                    <template slot-scope="{ scope, $index }">
                      <el-input
                        v-model="tableDatas[$index].value"
                        placeholder="请输入属性值"
                      ></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column fixed="right" align="center" label="操作">
                    <template slot-scope="{ scope, $index }">
                      <el-button @click="dels($index)" type="text" size="small"
                        >删除</el-button
                      >
                    </template>
                  </el-table-column>
                </el-table>
                <el-button
                  @click="addbut"
                  type="primary"
                  style="margin-left: 45%"
                  plain
                  icon="el-icon-plus"
                  circle
                  size="small"
                ></el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="isAddModal = false">取 消</el-button>
          <el-button type="primary" @click="submit" :loading="btnLoading"
            >确 定</el-button
          >
        </span>
      </el-dialog>
      <el-dialog
        :visible.sync="dialogVisible"
        style="z-index: 1999"
        width="30%"
      >
        <a :href="dialogImageUrl" target="downloadFile"
          ><img width="100%" :src="dialogImageUrl" alt=""
        /></a>
        <div style="width: 100%; text-align: center">点击下载二维码</div>
      </el-dialog>
    </div>
    <div class="home-content" v-else>
      <seeList
        @back="back"
        :seeId="seeId"
        :equipmentName="equipmentName"
      ></seeList>
    </div>
  </div>
</template>

<script>
import seeList from "./seeList";
import upload from "@/components/upload";
import UnpackAndDownImage from "@/utils/zipDownLoad";
import qs from "qs";
export default {
  components: {
    seeList,
    upload,
  },
  data() {
    return {
      searchForm: {
        name: "",
        deviceNumber:""
      },      
      seeFlags: true,
      isAddModal: false,
      btnLoading: false,
      equipmentName: "",
      dialogVisible: false,
      dialogImageUrl: "",
      isShowloading: false,
      modalTitle: "新增",
      currentPage: 1, // 当前页码
      total: 20, // 总条数
      pageSize: 10, // 每页的数据条数
      addDataRules: {
        name: [{ required: true, message: "请输入设备名称", trigger: "blur" }],
        deviceNumber: [
          { required: true, message: "请输入设备编号", trigger: "blur" },
        ],
        deviceAddress: [
          { required: true, message: "请输入设备位置", trigger: "blur" },
        ],
        deviceImg: [
          { required: true, message: "请上传设备图片", trigger: "blur" },
        ],
      },
      tableDatas: [],
      addData: {
        deviceNumber: "",
        name: "",
        deviceAddress: "",
        deviceDesc: "",
        deviceImg: "",
        qrCode: "",
      },
      imgs: [],
      managers: [],
      tableData: [],
    };
  },
  watch: {
    //监听表格数据变化时回显，判断有数据时及弹窗绑定值为true时调用回显,不然会报同上问题
    tableData(newVal) {
      if (newVal.length > 0) {
        this.showSelection();
      }
    },
  },
  methods: {
    //多选
    handleSelect(selection, row) {
      //声名标记，判断已选择项数组是否存在当前选中项，若存在删除该项，不存在则添加
      let flag;
      //深拷贝已选择项，我这里是兄弟组件传值，改变原数组的话会导致还没点击确定，兄弟组件就接到了新值
      let newArr = JSON.parse(JSON.stringify(this.managers));
      newArr.forEach((item, index) => {
        if (item.id == row.id) {
          newArr.splice(index, 1);
          flag = true;
        }
      });
      if (!flag) {
        newArr.push({ id: row.id, img: row.qrCode });
      }
      this.managers = newArr;
    },
    //全选
    handleSelectAll(selection) {
      //参数selection为当前页的选中项数组,长度大于0则为全部选中，相反为全部取消选中
      if (selection.length > 0) {
        //stateArr为暂存已选择项,深拷贝selection数组，这里是将selection元素全部添加到stateArr
        this.stateArr = JSON.parse(JSON.stringify(selection));
        //深拷贝已选中项数组，因业务需求我这里是兄弟组件传入的已选中项，
        //由于是点击确定按钮时传值不另外声名的话会导致改变managers时
        //兄弟组件监听到变化直接改变了managers数组
        let newManagers = JSON.parse(JSON.stringify(this.managers));
        selection.forEach((item) => {
          newManagers.push({ id: item.id, img: item.qrCode });
        });
        //数组中对象根据id去重
        var objItem = {},
          newAry = [];
        for (var i = 0; i < newManagers.length; i++) {
          if (!objItem[newManagers[i].id]) {
            newAry.push(newManagers[i]);
            objItem[newManagers[i].id] = true;
          }
        }
        this.managers = newAry;
      } else {
        //取消全部选中的状态，此时stateArr为当前业的表格数据，用于判断取消选中的哪页数据
        this.stateArr = JSON.parse(JSON.stringify(this.tableData));
        //map方法将每项的id放 入set数组中
        var set = this.stateArr.map((item) => {
          return item.id;
        });
        //根据id过滤掉已选择项数组中存在这些id的数据
        var resArr = this.managers.filter((item) => !set.includes(item.id));
        this.managers = resArr;
      }
    },
    //表格多选回显
    showSelection() {
      let arr = [];
      let set = this.managers.map((item) => {
        return item.id;
      });
      //过滤出已选择项和table数据中id对应上的数据，完成回显
      arr = this.tableData.filter((item) => {
        return set.includes(item.id);
      });
      this.$nextTick(() => {
        arr.forEach((item) => {
          this.$refs.table.toggleRowSelection(item);
        });
      });
    },
    // 批量下载图片
    downloadimg() {
      if (this.managers.length > 0) {
        this.imgs = this.managers.map((res) => res.img);
        let arr = [];
        this.imgs.forEach((item) => {
          this.$Apis.verificationBase64({ imgUrl: item }).then((res) => {
            arr.push("data:image/jpg;base64," + res.data);
            if (arr.length == this.imgs.length) {
              new UnpackAndDownImage({
                imgSrcList: this.imgs,
                imgBase64: arr,
                folderName: "二维码文件",
                onError(err) {
                  // console.log(err)
                },
                onProgress(res) {
                  // console.log('onProgress',res)
                },
                onSuccess(res) {
                  // console.log('onSuccess',res)
                },
              });
            }
          });
        });
      } else {
        this.$message.warning("请选择");
      }
    },
    onLoad() {
      this.isShowloading = true;
      let page = {
        current: this.currentPage,
        size: this.pageSize,
        ...this.searchForm
      };
      this.$Apis.deviceUpholdList(page).then((res) => {
        this.isShowloading = false;
        if (res.code == 200) {
          let { current, list, pages, total } = res.data;
          this.currentPage = current;
          this.size = pages;
          this.total = total;
          this.tableData = list;
        }
      });
    },
    // 重置按钮
    restSearch() {
      for (let item in this.searchForm) {
        this.searchForm[item] = "";
      }
      this.onLoad();
    },    
    addbut() {
      this.tableDatas.push({
        label: "",
        value: "",
      });
    },
    dels(index) {
      this.tableDatas.splice(index, 1);
    },
    // 设备列表新增
    add() {
      this.addData.deviceNumber = "";
      this.addData.name = "";
      this.addData.deviceAddress = "";
      this.addData.deviceImg = "";
      this.addData.deviceDesc = "";
      this.tableDatas = [];
      this.isAddModal = true;
      this.modalTitle = "新增";
    },
    // 提交
    submit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.btnLoading = true;
          let id = "";
          if (this.modalTitle == "修改") {
            id = this.addData.id;
          }
          var data = {
            id,
            name: this.addData.name,
            deviceNumber: this.addData.deviceNumber,
            deviceAddress: this.addData.deviceAddress,
            deviceImg: this.addData.deviceImg,
            deviceDesc: this.tableDatas,
          };
          this.$Apis.deviceUpholdUpdata(data).then((res) => {
            this.btnLoading = false;
            this.isAddModal = false;
            if (res.code == 200) {
              this.onLoad();
              this.$message.success("操作成功");
            } else {
              this.$message.warning(res.msg);
            }
          });
        }
      });
    },
    // 修改
    updata(row) {
      this.addData = JSON.parse(JSON.stringify(row));
      this.tableDatas = JSON.parse(this.addData.deviceDesc);
      this.isAddModal = true;
      this.modalTitle = "修改";
    },
    // 复制设备
    copyUpdata(row) {
      this.addData = JSON.parse(JSON.stringify(row));
      this.tableDatas = JSON.parse(this.addData.deviceDesc);
      this.isAddModal = true;
      this.modalTitle = "复制";
    },
    // 查看记录
    see(row) {
      console.log(row);
      this.seeId = row.id;
      this.equipmentName = row.name;
      this.seeFlags = false;
    },
    //删除
    del(row) {
      var data = {
        id: row.id,
      };
      this.$confirm("您确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$Apis.deviceUpholdDelete(data).then((res) => {
            if (res.code == 200) {
              this.onLoad();
              this.$message.success("删除成功");
            } else {
              this.$message.warning(res.msg);
            }
          });
        })
        .catch((err) => {});
    },
    back() {
      this.seeFlags = true;
    },
    //每页条数改变时触发 选择一页显示多少行
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.onLoad();
    },
    //当前页改变时触发 跳转其他页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.onLoad();
    },
    // 生成二维码
    qrCode(row) {
      var data = {
        id: row.id,
        page: "pages/thingYard/archives/archives",
        // page: "pages/home/home",
      };
      this.$confirm("您确定要生成二维码吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$Apis.generateQrCode(data).then((res) => {
            if (res.code == 200) {
              this.onLoad();
              this.$message.success("成功");
            } else {
              this.$message.warning(res.msg);
            }
          });
        })
        .catch((err) => {});
    },
    // 下载二维码
    addRecord(e) {
      this.dialogVisible = true;
      this.dialogImageUrl = e;
    },
  },
  mounted() {
    this.onLoad();
  },
};
</script>

<style>
.home-container {
  padding: 10px;
  padding-top: 5px;
}
.home-content {
  padding: 10px;
  border-radius: 5px;
  background: #fff;
}
.tree {
  margin-top: 10px;
  width: 300px;
  z-index: 999;
  background-color: #fff;
  padding: 20px;
  height: 200px;
  overflow: auto;
  border: 1px solid #eee;
  border-radius: 5px;
}
#app-container {
  text-align: center;
}
</style>